module.exports = __webpack_public_path__ + "img/6.6e519f0a.jpg";